// src/data/demons.js

export const PERKS_LIST = [
  { id: "illegal_serve",   label: "Illegal Serve",          colere:5,  chaos:15, tcho:15, matos:0,  violence:5,  destruct:5  },
  { id: "cheater",         label: "Cheater",                colere:10, chaos:20, tcho:20, matos:0,  violence:10, destruct:5  },
  { id: "lucky_edge",      label: "Lucky Edge & Nets",      colere:0,  chaos:10, tcho:25, matos:0,  violence:0,  destruct:0  },
  { id: "no_backend",      label: "No Backend",             colere:5,  chaos:5,  tcho:10, matos:0,  violence:5,  destruct:10 },
  { id: "sweater_guy",     label: "Sweater Guy",            colere:0,  chaos:5,  tcho:15, matos:10, violence:0,  destruct:0  },
  { id: "tennis_guy",      label: "Tennis Guy",             colere:5,  chaos:10, tcho:20, matos:5,  violence:10, destruct:5  },
  { id: "slapper",         label: "Slapper",                colere:15, chaos:15, tcho:10, matos:0,  violence:20, destruct:15 },
  { id: "excuse_guy",      label: "Excuse Guy",             colere:10, chaos:5,  tcho:30, matos:0,  violence:5,  destruct:0  },
  { id: "equipment_junky", label: "Equipment Junky",        colere:0,  chaos:10, tcho:10, matos:35, violence:0,  destruct:5  },
  { id: "diving_guy",      label: "Diving Guy",             colere:5,  chaos:20, tcho:15, matos:0,  violence:15, destruct:10 },
  { id: "too_many_man",    label: "Too Many Manierisms",    colere:0,  chaos:5,  tcho:25, matos:5,  violence:0,  destruct:0  },
  { id: "ball_breaker",    label: "Ball Breaker",           colere:20, chaos:15, tcho:5,  matos:0,  violence:25, destruct:20 },
  { id: "screamer",        label: "Screamer",               colere:25, chaos:15, tcho:5,  matos:0,  violence:20, destruct:10 },
  { id: "rager",           label: "Rager",                  colere:30, chaos:20, tcho:5,  matos:0,  violence:30, destruct:25 },
  { id: "high_toss",       label: "High Toss",              colere:0,  chaos:15, tcho:20, matos:0,  violence:5,  destruct:5  },
  { id: "perfect_no_tac",  label: "Perfect Tech No Tactic", colere:10, chaos:5,  tcho:15, matos:15, violence:5,  destruct:10 },
  { id: "trick_shot",      label: "Trick Shot",             colere:5,  chaos:25, tcho:15, matos:5,  violence:10, destruct:15 },
  { id: "old_monkey",      label: "Old Monkey Tactics",     colere:5,  chaos:10, tcho:25, matos:0,  violence:10, destruct:5  },
  { id: "defender",        label: "Defender",               colere:5,  chaos:-10,tcho:20, matos:0,  violence:5,  destruct:5  },
  { id: "attacker",        label: "Attacker",               colere:15, chaos:15, tcho:5,  matos:5,  violence:20, destruct:20 },
  { id: "spinner",         label: "Spinner",                colere:5,  chaos:15, tcho:20, matos:10, violence:5,  destruct:10 },
  { id: "looper",          label: "Looper",                 colere:10, chaos:10, tcho:10, matos:15, violence:15, destruct:20 },
  { id: "fisher",          label: "Fisher",                 colere:5,  chaos:5,  tcho:25, matos:0,  violence:5,  destruct:0  },
];

export const ONI_FORMS = [
  {
    id: "crab",     emoji: "🦀", name: "Crab Oni",     jp: "蟹鬼",
    desc: "Latéral. Imprévisible. Il part dans des directions que personne n'anticipe. Ses pinces claquent fort quand il perd.",
    base: { chaos:50, colere:35, destruct:30, tcho:75, matos:30, violence:35 },
    traits: ["fisher","spinner","too_many_man"],
  },
  {
    id: "monkey",   emoji: "🐒", name: "Monkey Oni",   jp: "猿鬼",
    desc: "Agile, frénétique, imprévisible. Il fait des trucs qu'aucun coach n'a jamais enseignés. Ça marche une fois sur deux.",
    base: { chaos:75, colere:45, destruct:40, tcho:60, matos:20, violence:45 },
    traits: ["trick_shot","old_monkey","diving_guy"],
  },
  {
    id: "chick",    emoji: "⚡", name: "Violent Chick Oni", jp: "暴力的な雛鬼",
    desc: "Ne sous-estime pas. La rage concentrée en un corps compact. Frappe plus fort que physiquement possible.",
    base: { chaos:60, colere:80, destruct:70, tcho:30, matos:25, violence:85 },
    traits: ["rager","screamer","slapper"],
  },
  {
    id: "turtle",   emoji: "🐢", name: "Turtle Oni",   jp: "亀鬼",
    desc: "Il attend. Encore. Et encore. Tu vas faire la faute. Il le sait. C'est démoniaquement patient.",
    base: { chaos:15, colere:20, destruct:10, tcho:65, matos:30, violence:15 },
    traits: ["defender","fisher","old_monkey"],
  },
  {
    id: "godzilla", emoji: "🦖", name: "Godzilla Oni", jp: "ゴジラ鬼",
    desc: "Pure destruction. Chaque frappe est un tremblement de terre. Il ne joue pas au ping, il l'écrase.",
    base: { chaos:65, colere:70, destruct:90, tcho:20, matos:40, violence:90 },
    traits: ["attacker","ball_breaker","rager"],
  },
  {
    id: "rabbit",   emoji: "🐇", name: "Rabbit Oni",   jp: "兎鬼",
    desc: "Vitesse pure. Il est déjà à la balle suivante quand tu joues encore la première. Épuisant à affronter.",
    base: { chaos:55, colere:30, destruct:35, tcho:45, matos:25, violence:40 },
    traits: ["attacker","looper","no_backend"],
  },
  {
    id: "frog",     emoji: "🐸", name: "Frog Oni",     jp: "蛙鬼",
    desc: "Ses effets sont une magie noire. La balle fait des choses que la physique interdit. Les gens détestent jouer contre lui.",
    base: { chaos:60, colere:35, destruct:30, tcho:70, matos:55, violence:35 },
    traits: ["spinner","illegal_serve","high_toss"],
  },
  {
    id: "lion",     emoji: "🦁", name: "Lion Oni",     jp: "獅子鬼",
    desc: "Dominant. Souverain. Il joue comme s'il avait déjà gagné. Parfois c'est vrai. Parfois c'est agaçant.",
    base: { chaos:45, colere:55, destruct:65, tcho:40, matos:45, violence:70 },
    traits: ["attacker","looper","screamer"],
  },
  {
    id: "elephant", emoji: "🐘", name: "Elephant Oni", jp: "象鬼",
    desc: "Lent à démarrer. Implacable une fois lancé. Sa puissance de frappe est terrifiante. Il n'oublie jamais une défaite.",
    base: { chaos:30, colere:50, destruct:75, tcho:35, matos:50, violence:65 },
    traits: ["attacker","perfect_no_tac","equipment_junky"],
  },
  {
    id: "cheetah",  emoji: "🐆", name: "Cheetah Oni",  jp: "チーター鬼",
    desc: "L'accélération démoniaque. En un dixième de seconde il passe de l'immobilité à la frappe totale. Tu n'as pas le temps.",
    base: { chaos:60, colere:40, destruct:55, tcho:35, matos:35, violence:60 },
    traits: ["attacker","looper","no_backend"],
  },
  {
    id: "gazelle",  emoji: "🦌", name: "Gazelle Oni",  jp: "ガゼル鬼",
    desc: "Élégance mortelle. Ses déplacements sont beaux. Ses frappes sont précises. Il souffre en silence.",
    base: { chaos:35, colere:25, destruct:40, tcho:55, matos:30, violence:45 },
    traits: ["attacker","spinner","too_many_man"],
  },
  {
    id: "seal",     emoji: "🦭", name: "Seal Oni",     jp: "アザラシ鬼",
    desc: "Il applaudit ses propres points. Il applaudit les points adverses. Il applaudit tout. C'est inquiétant.",
    base: { chaos:40, colere:15, destruct:20, tcho:80, matos:20, violence:15 },
    traits: ["excuse_guy","too_many_man","lucky_edge"],
  },
];

export const QUIZ_STEPS = [
  {
    id: "style",
    question: "Comment tu joues, honnêtement ?",
    subtitle: "Pas ce que tu voudrais être. Ce que tu fais vraiment quand c'est 10-10.",
    options: [
      { value:"attacker", icon:"⚡", label:"ATTAQUANT",  desc:"Je smash. Je loope. Je frappe fort. Parfois dans le filet. Souvent dans le filet." },
      { value:"defender", icon:"🛡️", label:"DÉFENSEUR",  desc:"Je renvoie. Je pousse. J'attends que l'autre fasse la faute. Ça marche souvent." },
      { value:"spinner",  icon:"🌀", label:"SPINNEUR",   desc:"Service vicieux. Effets douteux. La balle fait des trucs bizarres." },
      { value:"fisher",   icon:"🎣", label:"PÊCHEUR",    desc:"Je joue court. Je varie. J'attends l'erreur. Les gens me haïssent. Je comprends." },
    ],
    statMods: {
      attacker: { colere:+15, chaos:+15, destruct:+20, violence:+15 },
      defender: { chaos:-15,  tcho:+20,  colere:-10 },
      spinner:  { tcho:+15,   chaos:+10, matos:+10 },
      fisher:   { tcho:+25,   chaos:+5 },
    }
  },
  {
    id: "mental",
    question: "10-10, jeu décisif. Qu'est-ce qui se passe en toi ?",
    subtitle: "La vérité sort ici.",
    options: [
      { value:"rage",   icon:"🔥", label:"LA RAGE MONTE",      desc:"Je veux détruire la raquette, la table, l'adversaire, la salle, moi-même." },
      { value:"excuse", icon:"😤", label:"L'EXCUSE SE PRÉPARE", desc:"La lumière. Le sol. Mon matos. Ma blessure du dos de 2019. La balle était bizarre." },
      { value:"clutch", icon:"🧊", label:"LE CALME TOTAL",      desc:"Je ralentis. Je respire. Je joue mon jeu. Parfois ça marche, parfois non." },
      { value:"chaos",  icon:"🎲", label:"LE CHAOS PUR",        desc:"Je joue un trick shot que j'ai jamais réussi à l'entraînement. Parfois ça rentre." },
    ],
    statMods: {
      rage:   { colere:+25, violence:+20, chaos:+15, destruct:+15 },
      excuse: { tcho:+20,   chaos:-15,    colere:+10 },
      clutch: { chaos:-20,  colere:-10 },
      chaos:  { chaos:+25,  destruct:+15, tcho:+10, violence:+10 },
    }
  },
  {
    id: "matos",
    question: "Ton rapport au matériel.",
    subtitle: "Dis la vérité sur tes raquettes.",
    options: [
      { value:"junky",  icon:"🛒", label:"EQUIPMENT JUNKY",   desc:"J'ai 4 raquettes. Chaque défaite = nouveau revêtement. Je cherche encore la raquette parfaite." },
      { value:"stable", icon:"🪨", label:"STABLE",            desc:"Même raquette depuis 3 ans. Je la connais. On souffre ensemble." },
      { value:"picot",  icon:"👹", label:"PICOT DÉMONIAQUE",  desc:"Picots longues d'un côté. Ouais. Je sais ce que tu penses. Assume." },
      { value:"fancy",  icon:"✨", label:"FASHION FIRST",     desc:"La raquette doit être belle. Et la tenue. Et les chaussures. Le jeu suit." },
    ],
    statMods: {
      junky:  { matos:+35, chaos:+10, tcho:+10 },
      stable: { matos:-10, chaos:-10 },
      picot:  { matos:+20, chaos:+25, tcho:+15, violence:+10 },
      fancy:  { matos:+25, tcho:+15 },
    }
  },
  {
    id: "behavior",
    question: "Ce que les autres voient de toi en match.",
    subtitle: "Ce que TU penses qu'ils voient. Ou ce qu'ils voient vraiment.",
    options: [
      { value:"screamer", icon:"📢", label:"THE SCREAMER",          desc:'"Allez !" à chaque point. Même les points perdus. Surtout les points perdus.' },
      { value:"silent",   icon:"🗿", label:"THE SILENT ONI",        desc:"Rien. Aucune expression. Les gens savent pas si je suis zen ou sur le point d'exploser." },
      { value:"ritual",   icon:"🔮", label:"TOO MANY MANIERISMS",   desc:"Rituel avant chaque service. Je rebondis la balle 7 fois exactement. Les gens attendent." },
      { value:"actor",    icon:"🎭", label:"THE ACTOR",             desc:"Je gère mon image. Toujours beau perdant. Jusqu'au vestiaire." },
    ],
    statMods: {
      screamer: { colere:+20, violence:+15, chaos:+10, destruct:+10 },
      silent:   { colere:-10, chaos:-5 },
      ritual:   { tcho:+25, chaos:-5 },
      actor:    { tcho:+15, colere:-5 },
    }
  },
];

// Determine best Oni form from stats + perks
export function computeDemon(answers, selectedPerks) {
  // Base stats
  let stats = { chaos:30, colere:30, destruct:30, tcho:30, matos:30, violence:30 };

  // Apply quiz mods
  QUIZ_STEPS.forEach(step => {
    const answer = answers[step.id];
    const mods = step.statMods[answer] || {};
    Object.entries(mods).forEach(([k,v]) => { stats[k] = clamp((stats[k]||0) + v); });
  });

  // Apply perk mods
  selectedPerks.forEach(perkId => {
    const perk = PERKS_LIST.find(p => p.id === perkId);
    if (!perk) return;
    ['colere','chaos','tcho','matos','violence','destruct'].forEach(k => {
      stats[k] = clamp((stats[k]||0) + (perk[k]||0));
    });
  });

  // Find best matching Oni form
  let bestOni = ONI_FORMS[0];
  let bestScore = -Infinity;

  ONI_FORMS.forEach(oni => {
    // Score = similarity to oni base stats + trait overlap
    let score = 0;
    const oniBase = oni.base;
    Object.keys(stats).forEach(k => {
      score -= Math.abs((stats[k] || 0) - (oniBase[k] || 0));
    });
    // Trait match bonus
    const traitMatch = oni.traits.filter(t => selectedPerks.includes(t)).length;
    score += traitMatch * 30;

    if (score > bestScore) { bestScore = score; bestOni = oni; }
  });

  // Merge base + computed
  const finalStats = {};
  Object.keys(stats).forEach(k => {
    finalStats[k] = Math.round((stats[k] + bestOni.base[k]) / 2);
  });

  return { oni: bestOni, stats: finalStats, perks: selectedPerks };
}

function clamp(v) { return Math.max(0, Math.min(99, v)); }
